module.exports = __webpack_public_path__ + "img/sec2.2.b7c4d537.png";